import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { renderTableTitle } from "@/utils/render.jsx";
import OverflowTooltipText from "@/components/Common/overflow-tooltip-text.vue";
import qrcode from "qrcode";
import html2canvas from "html2canvas";
import request from "@/service/invites";
import editInviteModal from "@/components/invite/Modal/editor-Invite-Modal.vue";
import emptyImg from "@/assets/state/empty.png";
import { mapState } from "vuex";
import { getCurrentLanguageCode } from "@/utils/util";
export default {
  name: "InviteLinkDrawer",
  components: {
    "editor-invite-modal": editInviteModal
  },
  data() {
    const h = this.$createElement;
    return {
      visiable: false,
      label: "",
      editorInviteModalRef: null,
      status: "F",
      dataList: [],
      currentItem: {},
      radioList: [{
        label: $t("i2xr2", "有效"),
        code: "F"
      }, {
        label: $t("hvu02", "无效"),
        code: "T"
      }],
      columns: [{
        title: $t("ar84e54", "创建时间"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "createDatetime"
      }, {
        title: $t("chizf3", "创建人"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "createUser",
        width: 120
      }, {
        title: $t("arsqdh4", "加入部门"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "orgName",
        width: 150,
        render: (h, {
          row
        }) => this.tableTextNode(h, row.orgName, "invite-link-org-text")
      }, {
        title: $t("fl3fk3", "有效期"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "validityTypeLabel",
        render: (h, {
          row
        }) => {
          let {
            validityTypeLabel
          } = row;
          return h("div", {
            "class": "text-left flex gap-1"
          }, [h("i", {
            "class": "icon-time_shijian_time iconfont leading-[21px] text-[#BC71FD]"
          }), validityTypeLabel]);
        }
      }, {
        title: $t("jpdocw6", "是否需要审批"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "needApprove",
        render: (h, params) => {
          const approvalText = params.row.needApprove === "T" ? $t("wiiutl7", "需要管理员审核") : "-";
          return this.tableTextNode(h, approvalText, "invite-link-approval-text");
        }
      }, {
        title: $t("k1e32", "状态"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "isInvalid",
        render: (h, {
          row
        }) => {
          let {
            isInvalid
          } = row;
          return h("span", {
            class: isInvalid === "T" ? "bg-[#FFE6E6] text-[#E63535] p-1" : "bg-[#E3FFF1] text-[#05A660] p-1"
          }, isInvalid === "T" ? $t("hvu02", "无效") : $t("i2xr2", "有效"));
        }
      }, {
        title: $t("hkxb2", "操作"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        width: 160,
        key: "action",
        slot: "action"
      }]
    };
  },
  computed: {
    statusFlag() {
      return this.status === "F";
    },
    width() {
      return window.innerWidth > 1000 ? "600" : "80";
    },
    height() {
      return window.innerHeight - 750 > 300 ? window.innerHeight - 750 : 300;
    },
    validityTypeList() {
      return [{
        label: $t("ixe2", "7天"),
        value: 0
      }, {
        label: $t("1j7p3", "15天"),
        value: 1
      }, {
        label: $t("1kks3", "30天"),
        value: 2
      }, {
        label: $t("1p0y3", "90天"),
        value: 3
      }, {
        label: $t("dzch7w4", "永久有效"),
        value: 4
      }];
    },
    nodataContent() {
      let flag = this.dataList.length > 0;
      if (flag) {
        return null;
      } else {
        return `<div class="flex flex-col items-center gap-2"><img class='w-[100px]' src="${emptyImg}${$t('f0kozk1h', '" alt="" /><span class="text-[#000]">空空如也<span></div>')}`;
      }
    },
    deptName() {
      var _this$currentItem;
      return ((_this$currentItem = this.currentItem) === null || _this$currentItem === void 0 ? void 0 : _this$currentItem.orgName) || "";
    },
    ...mapState({
      user: state => state.user,
      languageCode: state => state.app.language
    })
  },
  methods: {
    inviteUrl(item) {
      // 邀请记录中的复制和二维码统一使用经过校验的当前语言码。
      const url = new URL("/Invites", location.origin);
      url.searchParams.set("inviteCode", item.inviteCode || "");
      const languageCode = getCurrentLanguageCode(this.languageCode);
      if (languageCode) {
        url.searchParams.set("language", languageCode);
      }
      return url.toString();
    },
    // 表格单元格共用真实宽度检测，避免长部门名称和审批文案换行撑高行高。
    tableTextNode(h, text, textClass) {
      const value = text === null || text === undefined || text === "" ? "—" : String(text);
      return h(OverflowTooltipText, {
        props: {
          text: value,
          maxWidth: 300,
          textClass,
          tooltipClass: "invite-link-text-tooltip",
          tooltipStyle: {
            display: "block",
            width: "100%",
            minWidth: 0,
            marginTop: "5px"
          }
        }
      });
    },
    // async getLastInviteLink() {
    //   let res = await request.getLatestInviteLink();
    //   console.log(res);
    // },
    async open() {
      this.status = "F";
      await this.getData();
      this.visiable = true;
    },
    async getData() {
      let res = await request.getInvitesList({});
      let {
        retVal: {
          datas
        }
      } = res;
      this.dataList = datas.map(item => {
        return {
          ...item,
          validityTypeLabel: this.validityTypeList[item.validityType].label
        };
      });
    },
    getInviteLinkList() {
      this.getData();
    },
    async copyLink(item) {
      const url = this.inviteUrl(item);
      let res = await this.copyToClipboard(url);
      if (res) {
        this.$Message.success($t("bkv2mw4", "复制成功"));
      } else {
        this.$Message.error($t("bktvvh4", "复制失败"));
      }
    },
    async downloadQrcode(item) {
      this.currentItem = item;
      const url = this.inviteUrl(item);

      // 生成二维码到canvas
      await qrcode.toCanvas(this.$refs.qrcodeCanvas, url, {
        width: 200,
        margin: 1
      });

      // 使用html2canvas下载带样式的二维码
      html2canvas(this.$refs.downloadRef, {
        scale: 2,
        backgroundColor: "#ffffff",
        useCORS: true,
        allowTaint: true
      }).then(canvas => {
        const link = document.createElement("a");
        link.download = $t("eqg8ci5", "邀请二维码");
        link.href = canvas.toDataURL("image/png");
        link.click();
      });
    },
    checkDetail(item) {
      this.$emit("check", item);
      this.visiable = false;
    },
    async clearInviteLink() {
      await this.getData();
      this.dataList[0] ? this.editInviteLink(this.dataList[0]) : this.$emit("clear");
    },
    async removeInviteLink(inviteCode) {
      this.$Modal.confirm({
        title: $t("hn562", "提示"),
        content: $t("m9jiv37", "确定要删除吗？"),
        onOk: async () => {
          let res = await request.deleteInviteLink({
            inviteCode
          });
          let {
            result,
            msg
          } = res;
          if (result === 0) {
            this.$Message.success(msg);
            await this.getData();
            if (this.status === "F") {
              this.dataList[0] ? this.editInviteLink(this.dataList[0]) : this.$emit("clear");
            }
          }
        }
      });
    },
    async editInviteLink() {
      let {
        retVal
      } = await request.getLatestInviteLink();
      this.$emit("edit", retVal);
    },
    editInviteLinkDetail(item) {
      this.$refs.editorInviteModalRef.open(item);
    },
    async init() {
      let {
        retVal
      } = await request.getLatestInviteLink();
      await this.getData();
      this.$emit("edit", retVal || {});
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        return navigator.clipboard.writeText(text).then(() => {
          return true;
        }).catch(() => {
          return false;
        });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          const successful = document.execCommand("copy");
          document.body.removeChild(textArea);
          return successful;
        } catch (err) {
          document.body.removeChild(textArea);
          return false;
        }
      }
    }
  },
  async mounted() {
    await this.init();
  }
};